'use client';

import { useEffect } from 'react';

import { metricClient } from '@/services/metricsClient';
import { runOnBrowserIdle } from '@/utils/runOnBrowserIdle';

export function useAnalytics() {
  useEffect(() => {
    runOnBrowserIdle(() => {
      metricClient.initialize();
    });
  }, []);
}
